import TabPanel, { ITabPanelOptions } from "devextreme-react/tab-panel";

export default function PromineoTabPanel(props: ITabPanelOptions) {
  return (
    <>
      <TabPanel {...props} />
    </>
  );
}
